import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';
import { SspApi } from '../../../api';
import { ContentHolder } from '../../../components/common';
import { humanize } from '../../../utils/helpers/text_formatters';
import { ButtonCopy } from '../../../components/common/buttons';

class Script extends Component {

  componentDidMount() {
    this.fetchResource();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchResource();
    }
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    const pixel = get(this.props, 'pixel.data', {});
    if (website.uuid && pixel.ssp_website_id !== website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.pixel.get(data));
    }
  }

  render() {
    const { pixel, isLoading, website } = this.props;
    const mainSnippet = get(pixel, 'data.main_snippet', null);
    const eventSnippet = get(pixel, 'data.event_snippet', null);
    const pixelStatus = get(pixel, 'data.status', null);
    return (
      <ContentHolder loading={isLoading}>
        <div>
          <div className={`alert alert-${pixelStatus === 'active' ? 'success' : 'warning'}`}>
            <strong>
              The pixel is in {humanize(pixelStatus).toLowerCase()} state on: {website.url}
            </strong>
          </div>

          <h3>1. Locate the search results page</h3>

          <p>
            Copy the entire snippet of code below and paste it in the website body
            of your serach results page.

            You can paste the snippet any where in the body, just above
            the &lt;/body&gt; tag.
          </p>

          <CopyToClipboard
            text={mainSnippet}
            onCopy={() => toastr.success('Script copied to clipboard!')}
          >
            <ButtonCopy
              btnLabel='Copy to clipboard'
            />
          </CopyToClipboard>

          <pre id="pixel-view" className="m-t-md">
            {mainSnippet}
          </pre> <br />

          <h3>2. Trigger the search event</h3>

          <p>
            Whenever a job is serached on your website using a keyword and location,
            an search event needs to be triggered.
          </p>

          <p>
            Add the event code anywhere in the body below the pixel code. This allows the event code
            to load along with the pixel code when the page loads.
          </p>

          <CopyToClipboard
            text={eventSnippet}
            onCopy={() => toastr.success('Event code copied to clipboard!')}
          >
            <ButtonCopy
              btnLabel='Copy to clipboard'
            />
          </CopyToClipboard>

          <pre id="pixel-event" className="m-t-md">
            {eventSnippet}
          </pre> <br />

          <p>
            If at any point you're stuck and need help installing the widget,
            please drop us an email at <b>contact@jobadx.com</b> and our technical support
            team will get in touch with you.
          </p>
        </div>
      </ContentHolder>
    );
  }
}

const mapStateToProps = (state) => {
  const { ssp } = state;
  return { pixel: ssp.pixel.data, isLoading: ssp.pixel.loading };
};

export default connect(mapStateToProps)(Script);
